import styled from 'styled-components';

import {
  icons,
} from 'web-styled';

export const Trophy = styled.div`
  width: 57px;
  height: 66px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-image: url(${icons.cupLarge});
`;
